export default __webpack_public_path__ + "static/media/removeRed.39ce611b.svg";